<canvas #overlay_bg class="overlay"></canvas>
<canvas #overlay_fg class="overlay"></canvas>
